// ai-mock.ts — Static mock data for AIPage.
// TODO(ai-API-PR): Replace with /api/v1/agent/search (SSE stream)
// NEVER actually call /api/v1/agent/search — pure client mock.

export const AI_SUGGESTIONS = [
  'Plan a 7-day Bali trip under ₹1,25,000',
  'Cheapest dates to fly to Tokyo in spring',
  'Romantic getaway, 4 nights, no flights past 9pm',
  'Surf trip with friends, August, under ₹2 lakh',
] as const;

export interface AIPlanItem {
  type: 'flight' | 'hotel';
  label: string;
  sub: string;
  priceInr: number;
}

export interface AIPlan {
  id: string;
  title: string;
  nights: number;
  items: AIPlanItem[];
  totalInr: number;
  budgetLabel: string;
}

export const AI_PLANS: AIPlan[] = [
  {
    id: 'plan1',
    title: '7 nights · Bali',
    nights: 7,
    items: [
      { type: 'flight', label: 'AirAsia D7', sub: 'BLR → DPS · 8h direct', priceInr: 35800 },
      { type: 'hotel', label: 'Bisma Eight, Ubud', sub: '3 nights · 9.2 ★', priceInr: 46000 },
      { type: 'hotel', label: 'Katamama, Canggu', sub: '4 nights · 8.9 ★', priceInr: 48400 },
    ],
    totalInr: 123400,
    budgetLabel: 'under budget',
  },
  {
    id: 'plan2',
    title: '5 nights · Tokyo',
    nights: 5,
    items: [
      { type: 'flight', label: 'Singapore Airlines SQ', sub: 'BLR → NRT · 1 stop · SIN', priceInr: 58200 },
      { type: 'hotel', label: 'Park Hyatt Tokyo', sub: '5 nights · 9.4 ★', priceInr: 87500 },
    ],
    totalInr: 145700,
    budgetLabel: 'best value',
  },
  {
    id: 'plan3',
    title: '4 nights · Santorini',
    nights: 4,
    items: [
      { type: 'flight', label: 'Qatar Airways QR', sub: 'BLR → JTR · 1 stop · DOH', priceInr: 51900 },
      { type: 'hotel', label: 'Canaves Oia Suites', sub: '4 nights · 9.7 ★', priceInr: 74200 },
    ],
    totalInr: 126100,
    budgetLabel: 'romantic pick',
  },
  {
    id: 'plan4',
    title: '7 nights · surf · Bali',
    nights: 7,
    items: [
      { type: 'flight', label: 'IndiGo 6E', sub: 'BLR → DPS · 1 stop · KUL', priceInr: 33200 },
      { type: 'hotel', label: 'Finns Beach Club Villas', sub: '3 nights · 8.8 ★', priceInr: 32400 },
      { type: 'hotel', label: 'Katamama, Canggu', sub: '4 nights · 8.9 ★', priceInr: 48400 },
    ],
    totalInr: 114000,
    budgetLabel: 'surf budget',
  },
  {
    id: 'plan5',
    title: '6 nights · Lisbon',
    nights: 6,
    items: [
      { type: 'flight', label: 'Air India AI', sub: 'BLR → LIS · 1 stop · DEL', priceInr: 45600 },
      { type: 'hotel', label: 'Bairro Alto Hotel', sub: '6 nights · 9.1 ★', priceInr: 68400 },
    ],
    totalInr: 114000,
    budgetLabel: 'weekend fave',
  },
];

export interface ChatHistoryEntry {
  id: string;
  title: string;
  preview: string;
  timestamp: string;
}

export const CHAT_HISTORY: ChatHistoryEntry[] = [
  { id: 'c1', title: 'Bali 7 nights', preview: 'Plan a 7-day Bali trip under ₹1.25L', timestamp: '2 days ago' },
  { id: 'c2', title: 'Tokyo spring flights', preview: 'Cheapest dates to fly Tokyo in March', timestamp: '5 days ago' },
  { id: 'c3', title: 'Santorini romantic', preview: '4 nights, no flights past 9pm', timestamp: '1 week ago' },
  { id: 'c4', title: 'Bali surf trip', preview: 'Surf trip August, under ₹2L with 3 friends', timestamp: '2 weeks ago' },
];

export const AI_RESPONSES: Record<number, string> = {
  0: "got it — Bali, 7 nights, under ₹1.25 lakh total. I've stitched together a cheap-but-pretty plan:",
  1: "perfect — Tokyo in spring it is. Here's the best value combo I found for cherry blossom season:",
  2: "a romantic escape, no red-eye flights, 4 nights. here's the dreamiest option that fits:",
  3: "surf trip with friends, August, budget-friendly. here's a board-friendly itinerary:",
  4: "Lisbon is such a good call. here's a 6-night plan that won't wreck your wallet:",
};

export function getAIResponse(planIndex: number): { text: string; plan: AIPlan } {
  const idx = planIndex % AI_PLANS.length;
  const plan = AI_PLANS[idx];
  const text = AI_RESPONSES[idx];
  // Both will always be defined because idx is always within bounds,
  // but we guard to satisfy noUncheckedIndexedAccess.
  if (!plan || !text) {
    return { text: AI_RESPONSES[0] ?? 'got it — here\'s a plan:', plan: AI_PLANS[0] ?? { id: 'fallback', title: '7 nights', nights: 7, items: [], totalInr: 0, budgetLabel: '' } };
  }
  return { text, plan };
}
